import cn from 'classnames'
import { ProgressBar } from '@components/ProgressBar'
import { ReportCategoryDetailProps } from './interface'

export function ReportCategoryDetail({
  data,
  topThree,
  maxValue,
  className,
}: ReportCategoryDetailProps) {
  return (
    <div
      className={cn(
        'grid grid-cols-1 gap-y-[10px] text-[14px] font-light',
        className
      )}
    >
      {data.map((item, i) => (
        <div key={i} className='flex gap-x-[10px] items-center'>
          <div className='w-[160px] text-secondary'>{item.name}</div>
          <div
            className={cn('w-[60px] text-right', {
              'text-primary': topThree.some(element => element.id === item.id),
              'text-secondary-100': !topThree.some(
                element => element.id === item.id
              ),
            })}
          >
            <span>{item.value.toLocaleString()}</span>
          </div>
          <ProgressBar
            value={item.value}
            max={maxValue}
            className='flex-1'
            progressBarClassName={cn('rounded-full', {
              'bg-primary': topThree.some(element => element.id === item.id),
              'bg-gray-400': !topThree.some(element => element.id === item.id),
            })}
          />
        </div>
      ))}
    </div>
  )
}
